import React from "react";
import "../../styles/components/utils/DegradedHealthOverlay.css";
import LoadingDots from "tenant/loading_dots.gif";

const DegradedHealthOverlay: React.FC = () => {
  return (
    <div className="degraded-health-overlay">
      <div className="degraded-health-box">
        <div className="degraded-health-message">
          We're having a bit of trouble — hang tight while we sort it out.
        </div>
        <div>
          <img src={LoadingDots} alt="Loading..." className="degraded-health-dots" />
        </div>
      </div>
    </div>
  );
};

export default DegradedHealthOverlay;
